import React from "react";
import woodsLocationMap from "../../assets/woods-images/woods-location-map.avif";

export default function LocationWoods() {
  return (
    <section className="woods-location-section" id="woods-location">
      <img
        src={woodsLocationMap}
        alt="Vessella Woods location map"
        className="woods-location-iframe"
        loading="lazy"
      />
    </section>
  );
}
